export const CURRENCY_MAP = {
  USD: "USD",
  BYN: "р.",
};
